import { useShareToken } from '@/features/admin-interview';

import { getSecurityTokens, setSecurityTokens } from './authUtils';

export const useSecurityTokens = () => {
  return [getSecurityTokens(), setSecurityTokens] as const;
};

export const useAuth = () => {
  const [token] = useSecurityTokens();
  const shareToken = useShareToken();

  const anonymousShared = shareToken && !token;

  return {
    anonymousShared,
    token,
    shareToken,
  };
};
